import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { apiRequest } from "../services/apiClient";
import "./AuthPage.css";

export default function ResetPasswordConfirmPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Passwords do not match."); return; }
    if (password.length < 6) { setError("Password must be at least 6 characters."); return; }
    setLoading(true);
    try {
      await apiRequest("/auth/user-password-reset/confirm", { method: "POST", body: JSON.stringify({ token, newPassword: password }) });
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  if (!token) {
    return (
      <div className="auth-page">
        <div className="auth-card anim-fade-in-up">
          <div className="auth-heading"><h2>Invalid link</h2><p>This password reset link is missing its token.</p></div>
          <Link to="/login">Back to sign in</Link>
        </div>
      </div>
    );
  }

  if (done) {
    return (
      <div className="auth-page">
        <div className="auth-card anim-fade-in-up">
          <div className="auth-heading"><h2>Password updated</h2><p>You can now sign in with your new password.</p></div>
          <button className="auth-tab active" onClick={() => navigate("/login")}>Go to sign in</button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card anim-fade-in-up">
        <div className="auth-heading"><h2>Set a new password</h2><p>Choose a new password for your account</p></div>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-field">
            <label>New Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Min. 6 characters" required autoComplete="new-password" />
          </div>
          <div className="auth-field">
            <label>Confirm Password</label>
            <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Re-enter password" required autoComplete="new-password" />
          </div>
          {error && <div className="auth-error">{error}</div>}
          <button type="submit" className="auth-submit" disabled={loading}>{loading ? "Saving..." : "Set new password"}</button>
        </form>
      </div>
    </div>
  );
}
